import React,{ Component } from 'react';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import * as Icon from 'react-feather';
import { getStatus } from '../../../Utilities/Common';

export default class Timeline extends Component{

    renderTimeline(){
        const data = [];
        const { logs } = this.props;
        logs.map((log,index) => {
            const { device = "", status: logStatus, created_at, comment, user: { email = ""} } = log;
            const status = getStatus(logStatus);
            const TimelineIcon = Icon[status.icon];
            data.push(
                <VerticalTimelineElement
                key={index}
                className="vertical-timeline-element--work"
                iconStyle={{ background: status.color, color: "#fff" }}
                icon={<TimelineIcon />}
                >
                    <strong style={{wordWrap:"break-word"}}>{email} changed the status to {status.name} at {created_at}</strong>
                    <p>{comment}</p>
                    <small className="text-muted">{device}</small>
                </VerticalTimelineElement>
            );
        });
        
        return data;

    }
    render(){
        return (
            <VerticalTimeline>
                {this.renderTimeline()}
            </VerticalTimeline>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/Timeline.js